<template>
  <div class="table-container">
    <div class="header-area">
      <h1>
        {{ $t('analytics.transactions_header') }}
      </h1>
    </div>
    <div class="table-area transactions">
      <TopTransactions :with-search="true" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  hydrateWhenIdle
} from 'vue-lazy-hydration'

export default {
  name: 'TransactionsComponent',
  components: {
    TopTransactions: hydrateWhenIdle(() => import('~/components/analytics/tables/TopTransactions'))
  },
  layout: 'new',
  async fetch({ store, error, route }) {
    try {
      const pageName = route.name.split('___')
      const seoData = store.getters['seos/seosByUri'](pageName[0])
      if (seoData === null) {
        await store.dispatch('seos/fetchSeos', {
          uri: route.name
        })
      }
    } catch (err) {
      error(err)
    }
  },
  head({ $config: { appUrl } }) {
    return {
      title: this.meta ? this.meta.title : this.$t('common.launching'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-description',
          name: 'og:description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-title',
          name: 'og:title',
          content: this.meta
            ? this.meta.title
            : this.$t('common.launching')
        },
        {
          hid: 'og-image',
          name: 'og:image',
          content: this.meta
            ? this.meta.image
            : appUrl + 'seo/default.jpg'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.meta ? this.meta.keyword : ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters('seos', [
      'seosByUri'
    ]),
    meta() {
      const pageName = this.$nuxt.$route.name.split('___')
      return this.seosByUri(pageName[0])
    }
  }
}
</script>

<style scoped>
  @import url('../../assets/css/new/analytics-page.css');
  @import url('../../assets/css/new/table.css');
</style>
